import { NgModule } from '@angular/core';
import { AsFormArrayPipe, AsFormControlPipe, AsFormGroupPipe } from './as-instance-of-form-element.pipe';



@NgModule({
  declarations: [
    AsFormGroupPipe,
    AsFormArrayPipe,
    AsFormControlPipe,
  ],
  exports: [
    AsFormGroupPipe,
    AsFormArrayPipe,
    AsFormControlPipe,
  ]
})
export class AsInstanceOfFormElementModule { }
